import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import type { ITemplateNode } from '@ifs-gcp/core';
import type { DocumentUploadWidgetChild } from '@ifs-gcp/core/models';

import { useGetAuditCaseDocumentDefinitions } from '@/queries/get-audit-case-document-definitions';
import { useGetAuditCaseDocuments } from '@/queries/get-audit-case-documents';
import { useAuditStore } from '@/store/auditStore';
import { getTranslation } from '@/utils/translations';

import { DocumentTypeWrapper } from './documents-type-wrapper';
import styles from './documents.module.scss';

interface WidgetDocumentsProps {
  element: ITemplateNode<DocumentUploadWidgetChild>;
}

export const WidgetDocuments = ({ element }: WidgetDocumentsProps) => {
  const { audit_case_uuid: auditCaseUuid = '' } = useParams();
  const {
    i18n: { language: uiLanguage },
  } = useTranslation();

  const moduleId = element.props.context[0];

  const translations = Object.fromEntries(
    Object.entries(element.props.translations).map(([key, value]) => [
      key,
      getTranslation(value, uiLanguage),
    ]),
  );

  const audit = useAuditStore((state) => state.audit)!;

  const { data: docsData } = useGetAuditCaseDocuments(auditCaseUuid, moduleId);
  const { data: defsData } = useGetAuditCaseDocumentDefinitions(
    auditCaseUuid,
    moduleId,
    uiLanguage,
    audit,
  );

  const definitions = defsData?.documentDefinitions ?? [];
  const documents = docsData?.documents ?? [];

  return (
    <div className={styles.container}>
      {definitions.map((documentDefinition) => (
        <DocumentTypeWrapper
          key={documentDefinition.id}
          documentDefinition={documentDefinition}
          documents={documents.filter((d) => d.docDefinitionId === documentDefinition.id)}
          auditCaseUuid={auditCaseUuid}
          moduleId={moduleId}
          translations={translations}
        />
      ))}
    </div>
  );
};
